export default __webpack_public_path__ + "static/media/icn_loading.96d21a04.gif";